import { useEffect } from 'react';

const CTRL = 'Control';
const SHIFT = 'Shift';
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';

type ArrowKeyHandler = () => void;

type KeyHandlers = {
  onDownKey?: ArrowKeyHandler;
  onLeftKey?: ArrowKeyHandler;
  onRightKey?: ArrowKeyHandler;
  onUpKey?: ArrowKeyHandler;
};

const useArrowKeys = (
  enableArrows: boolean,
  { onDownKey, onLeftKey, onRightKey, onUpKey }: KeyHandlers
) => {
  useEffect(() => {
    const keyListener = (evt: KeyboardEvent) => {
      if (
        !enableArrows ||
        // Events may come from touch devices
        (!!evt.getModifierState &&
          (evt.getModifierState(CTRL) || evt.getModifierState(SHIFT)))
      ) {
        return;
      }

      if (onDownKey && evt.code === ARROW_DOWN) {
        evt.preventDefault();
        onDownKey();
        return;
      }

      if (onLeftKey && evt.code === ARROW_LEFT) {
        evt.preventDefault();
        onLeftKey();
        return;
      }

      if (onRightKey && evt.code === ARROW_RIGHT) {
        evt.preventDefault();
        onRightKey();
        return;
      }

      if (onUpKey && evt.code === ARROW_UP) {
        evt.preventDefault();
        onUpKey();
      }
    };

    document.addEventListener('keydown', keyListener);
    return () => {
      document.removeEventListener('keydown', keyListener);
    };
  }, [enableArrows, onDownKey, onLeftKey, onRightKey, onUpKey]);
};

export default useArrowKeys;
